export class ObservacoesFichasModel {
  id_observacao: number;
  observacao_pt: string;
  observacao_en: string;
  observacao_es: string;
  cor: number = 1;
}



// WEBPACK FOOTER //
// ./src/app/observacoes-fichas/observacoes-fichas.model.ts